import { FileDocumentObjectTypes } from '@generated/graphql';

type FormAgreementOwner = {
  user?: { id?: string };
  account?: { id?: string };
  subAccount?: { id?: string };
  goal?: { id?: string };
  scheduledTransfer?: { id?: string };
  clientGroup?: { id?: string };
};

/**
 * Resolves the FileDocument { objectType, objectId } pair that corresponds to
 * an IncompleteFormAgreement's related entity.
 *
 * The priority matches `signFormAgreement` input precedence so that the
 * uploaded FileDocument is tied to the same entity the backend uses to
 * correlate the file with the pending agreement (e.g. a PAD_AGREEMENT is
 * attached to its `scheduledTransfer`, not to the user).
 */
export const resolveFileDocumentObject = (
  document: FormAgreementOwner,
  fallbackUserId: string,
): { objectType: FileDocumentObjectTypes; objectId: string } => {
  if (document.account?.id) {
    return {
      objectType: FileDocumentObjectTypes.Account,
      objectId: document.account.id,
    };
  }
  if (document.subAccount?.id) {
    return {
      objectType: FileDocumentObjectTypes.Subaccount,
      objectId: document.subAccount.id,
    };
  }
  if (document.goal?.id) {
    return {
      objectType: FileDocumentObjectTypes.Goal,
      objectId: document.goal.id,
    };
  }
  if (document.scheduledTransfer?.id) {
    return {
      objectType: FileDocumentObjectTypes.ScheduledTransfer,
      objectId: document.scheduledTransfer.id,
    };
  }
  if (document.clientGroup?.id) {
    return {
      objectType: FileDocumentObjectTypes.Clientgroup,
      objectId: document.clientGroup.id,
    };
  }
  if (document.user?.id) {
    return {
      objectType: FileDocumentObjectTypes.User,
      objectId: document.user.id,
    };
  }
  return {
    objectType: FileDocumentObjectTypes.User,
    objectId: fallbackUserId,
  };
};
